import { createSlice } from '@reduxjs/toolkit';
//import { fetchCount } from './counterAPI';

const initialState = {
  sub: null,
  firstName: null,
  lastName: null,
  email: null,
  emailVerified: null,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setUser: (state, action) => {
      state.sub = action.payload.sub;
      state.firstName = action.payload.firstName;
      state.lastName = action.payload.lastName;
      state.email = action.payload.email;
      state.emailVerified = action.payload.emailVerified;
    },
    setUserFirstName: (state, action) => {
      state.firstName = action.payload;
    },
    setUserLastName: (state, action) => {
      state.lastName = action.payload;
    },
    setUserEmail: (state, action) => {
      state.email = action.payload;
    },
    resetUser: () => initialState,
  },
});

export const {
  setUser,
  setUserFirstName,
  setUserLastName,
  setUserEmail,
  resetUser,
} = userSlice.actions;

// Selectors
export const selectUser = (state) => state.user;
export const selectUserFirstName = (state) => state.user.firstName;
export const selectUserLastName = (state) => state.user.lastName;
export const selectUserEmail = (state) => state.user.email;
export const selectUserEmailVerified = (state) => state.user.emailVerified;
export const selectIsLoggedIn = (state) => {
  if (state.user.sub) {
    return true;
  } else {
    return false;
  }
};

export default userSlice.reducer;
